import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './index.css';
import App from './App';

const FAVICON_ID = 'cineaste-favicon';
const NORMAL_ICON = '/popcorn1.png?v=5';

const root = ReactDOM.createRoot(document.getElementById('root'));

let loadingTimer = null;
let frame = 0;

function makeLoadingIcon(angle) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
      <circle cx="32" cy="32" r="25" fill="#111111" stroke="#333333" stroke-width="5"/>
      <path d="M32 7 A25 25 0 0 1 57 32"
        fill="none" stroke="#e5c07b" stroke-width="5"
        stroke-linecap="round"
        transform="rotate(${angle} 32 32)"/>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

function startFaviconAnimation() {
  const favicon = document.getElementById(FAVICON_ID);

  if (!favicon || loadingTimer) return;

  loadingTimer = window.setInterval(() => {
    favicon.href = makeLoadingIcon(frame);
    frame = (frame + 30) % 360;
  }, 100);
}

function stopFaviconAnimation() {
  if (loadingTimer) {
    window.clearInterval(loadingTimer);
    loadingTimer = null;
  }

  const favicon = document.getElementById(FAVICON_ID);

  if (favicon) {
    favicon.href = NORMAL_ICON;
  }
}

if (document.readyState !== 'complete') {
  startFaviconAnimation();
  window.addEventListener('load', stopFaviconAnimation, { once: true });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);